import { resources } from "@constants/hardcoded-strings";
import { formatMessageTemplate } from "@formatters/message-templates/message-template-formatter";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { setMessageTemplateDetails } from "@redux/actions/message-template-details-actions";
import { updateMessageTemplateRequest } from "@requests/axnadmin-core/update-message-templates";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { getUnformattedLanguageFiles } from "@utils/message-template/message-template-util";
import { Dispatch } from "redux";

export const updateMessageTemplateDetailsReduxRequest = (dispatch: Dispatch) => async (
    messageTemplate: FormattedMessageTemplate,
    axnCompanies: Array<AxnCompany>,
) => {
    const { data, error, body } = await updateMessageTemplateRequest(
        messageTemplate.id,
        messageTemplate.template,
        messageTemplate.name,
        messageTemplate.company?.id,
        messageTemplate.rpServiceID,
        getUnformattedLanguageFiles(messageTemplate.languages),
        messageTemplate.status,
        messageTemplate.uuid,
        messageTemplate.type,
        messageTemplate.permissions,
        messageTemplate.sender
    );

    if (data) {
        const formattedMessageTemplate = formatMessageTemplate({ ...data.transferObject, permissions: messageTemplate.permissions }, axnCompanies);
        dispatch(setMessageTemplateDetails(formattedMessageTemplate));

        displaySuccessModal(
            dispatch,
            resources.requests.updateMessageTemplate.success.title,
            resources.requests.updateMessageTemplate.success.message
        );
        return formattedMessageTemplate;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateMessageTemplate.error.title,
            resources.requests.updateMessageTemplate.error.message,
            null,
            null,
            body
        );
    }

    return null;
};